import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyByw-TZeIj4AYTSHQrHuRfyzBWxFmVChL4",
    authDomain: "grimoire-19c93.firebaseapp.com",
    projectId: "grimoire-19c93",
    storageBucket: "grimoire-19c93.appspot.com",
    messagingSenderId: "891388553067",
    appId: "1:891388553067:web:d7ca96c7281f470bcd8e2e",
    measurementId: "G-J59MG1JZW0"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth();
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });